module.exports = __webpack_public_path__ + "img/electric_pending_zone.c57910e2.svg";